import { ContextService } from '../../services/context_service';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';
import { ZusatzToolsZertifizierungTabelle1 } from './ZusatzToolsZertifizierungTabelle1';
import { ZusatzToolsZertifizierungTabelle2 } from './ZusatzToolsZertifizierungTabelle2';
import { ZusatzToolsZertifizierungTabelle3 } from './ZusatzToolsZertifizierungTabelle3';

interface ZusatztoolsZertifizierungTabellenProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface ZusatztoolsZertifizierungTabellenState {
    tabIndex: number;
}

export class ZusatztoolsZertifizierungTabellen extends
    React.Component<ZusatztoolsZertifizierungTabellenProps, ZusatztoolsZertifizierungTabellenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxZusatztoolsZertifizierungTabellen') || 0
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG_TABELLEN;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG_TABELLEN;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxZusatztoolsZertifizierungTabellen', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const tabRoutings: Array<any> = [
            { path: { ...RoutingIDs.ROUTE_ZERTIFIZIERUNG_TABELLE1 } },
            { path: { ...RoutingIDs.ROUTE_ZERTIFIZIERUNG_TABELLE2 } },
            { path: { ...RoutingIDs.ROUTE_ZERTIFIZIERUNG_TABELLE3 } }
        ];

        return (
            <Tabs
                className={'tabs-zusatztools'}
                selectedIndex={this.state.tabIndex}
                // onSelect={
                //     (tabIndex, lastIndex, event) => this.setState(
                //         { tabIndex },
                //         () => this.contextService.set('tabIdxZusatztoolsZertifizierungTabellen', this.state.tabIndex)
                //     )
                // }
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{ display: 'none' }}>
                    <Tab>Tabelle 1: Eingesetzte Energieträger</Tab>
                    <Tab>Tabelle 2: Energieverbraucher</Tab>
                    <Tab>Tabelle 3: Maßnahmen / Bewertung</Tab>
                </TabList>
                <TabPanel>
                    <ZusatzToolsZertifizierungTabelle1
                        data={this.props.data}
                    />
                </TabPanel>
                <TabPanel>
                    <ZusatzToolsZertifizierungTabelle2
                        data={this.props.data}
                    />
                </TabPanel>
                <TabPanel>
                    <ZusatzToolsZertifizierungTabelle3
                        data={this.props.data}
                    />
                </TabPanel>
            </Tabs>
        );
    }
}
